import Icon from "@mui/material/Icon/Icon"
import IconButton from "@mui/material/IconButton/IconButton"
import List from "@mui/material/List/List"
import ListItem from "@mui/material/ListItem/ListItem"
import ListItemIcon from "@mui/material/ListItemIcon/ListItemIcon"
import ListItemText from "@mui/material/ListItemText/ListItemText"
import Typography from "@mui/material/Typography"
import { memo } from "preact/compat"
import type { Item } from "./EditableList"
import { SkeletonList } from "./SkeletonList"

export function IneditableList(props: { items: Item[]; isReady: boolean }) {
  if (!props.isReady) return <SkeletonList />

  return (
    <List>
      {props.items.map((item: Item, index: number) => (
        <RankedItem index={index} item={item} />
      ))}
    </List>
  )
}

const RankedItem = memo(
  ({ index, item }: { index: number; item: Item }): JSX.Element => {
    return (
      <ListItem
        secondaryAction={
          <IconButton
            edge="end"
            aria-label="info"
            onClick={() => console.error("UNIMPLEMENTED: Info") } 
          >
            <Icon children="info" />
          </IconButton>
        }
      >
        <ListItemIcon onClick={() => console.error("UNIMPLEMENTED: Ranking Number") } >
          <Typography variant="h6">{index + 1}</Typography>
        </ListItemIcon>
        <ListItemText
          primary={item.content}
          onClick={() => console.error("UNIMPLEMENTED: Ranking Item") }
        />
      </ListItem>
    )
  },
)
